import styled, { css } from 'styled-components';
import { Menu } from 'antd';

// Import icons
import { ReactComponent as ProfileIcon } from 'assets/icons/ic_profile.svg';

// Import styles
import { flex, responsive, customMinResponsive, size } from 'components/styles';
import { ItemStyled } from 'components/elements/molecules/dropdown/styles';

// Import components
import { Button } from 'components/elements';

export const ButtonsContainer = styled.div`
	display: ${({ isMobile }) => (isMobile ? flex({ fd: 'column' }) : 'flex')};
	wrap: no-wrap;
`;

export const ButtonStyled = styled(Button)`
	font-weight: ${({ theme }) => theme.font.bold};
	font-size: ${({ theme: { authentication } }) => authentication.authButtons.fontSize}rem;
	max-height: 4rem;
	margin: 1rem;
	width: auto;

	${flex({ ai: 'center' })}

	${({ isAuth }) =>
		!isAuth &&
		css`
			margin-left: 0.8rem;
		`};

	${customMinResponsive(
		size.xsmall,
		css`
			padding: 1rem 2rem;
		`
	)}
`;

export const ButtonText = styled.span`
	direction: ltr;
	width: max-content;
	${flex()};
	color: ${({ theme: { authentication } }) => authentication.authButtons.color};

	svg {
		margin-left: 0.9rem;
		width: 1.1rem;
	}
`;

export const Username = styled.span`
	${responsive.medium(css`
		display: none;
	`)}
`;

export const ProfileIconStyled = styled(ProfileIcon)`
	margin-right: 0.4rem;
`;

export const LogoutItem = styled(ItemStyled)`
	padding: 0;
`;

export const ButtonLogout = styled(Button)`
	font-weight: ${({ theme }) => theme.font.normal};
	color: ${({ theme: { dropdown } }) => dropdown.menu.itemColor};
	text-align: left;
	padding: ${({ isMobile }) => (isMobile ? '0.5rem 0rem' : '0.5rem 1.2rem')};
	background-color: transparent;
	width: 100%;

	&:hover {
		color: ${({ theme: { dropdown } }) => dropdown.menu.itemHoverColor};
	}
`;

export const MenuStyled = styled(Menu)`
	${({ isMobile }) =>
		isMobile &&
		css`
			width: 100vw;
			padding: 1rem 4rem;
			margin-top: 0.8rem;
			border-radius: 0;
		`}
`;
